import { useQuery } from 'react-query';

import * as Api from '../api';
import * as Constants from '../constants';
import * as Mappers from '../mappers';

const useSumma = () => {
  const initialData = { item: Mappers.Summa() };

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, 'summa'],
    async () => {
      const { data } = await Api.Summa();

      return {
        item: Mappers.Summa(data && data.data)
      };
    },
    { initialData }
  );

  return { ...args, ...data };
};

export default useSumma;
